import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#004290",
      primaryHover: "#001d62",
    },
    logoImage: logo,
    backend: "https://kataloge.knuffmann.de/",
    directory: "/kiosk",
    header: {
      title: "Knuffmann",
      lineHeader: true
    },
    accToolbar: false,
    info: [
      {
      text: 'Impressum',
      link: 'https://www.knuffmann.de/rechtliches/impressum/'
    },
      {
      text: 'Datenschutz',
      link: 'https://www.knuffmann.de/rechtliches/datenschutz/'
    },
  ],
  };